import * as THREE from "three";
import {Vector3} from "three";
import add_renderer from "./renderer";
import {findPlanePerspective} from "./findPlanePerspective";
import store from "../store";

export const getPerspectiveCamera = async function (photoID, planeID) {
    const activeProjectGUID = store.state.route.params.projectUUID;
    this.imageSize = await store.dispatch("active/GET_ACTIVE_IMG_SIZE");
    this.width = this.imageSize.width;
    this.height = this.imageSize.height;
    this.camera = new THREE.PerspectiveCamera(70, this.width / this.height, 100, 10000);
    this.component = document.getElementById("debugThreejs");

    let cameraSettings = store.getters[`projectList/${activeProjectGUID}/photoList/${photoID}/planeList/${planeID}/CAMERA_SETTINGS`];
    if (cameraSettings) {
        this.camera.position.set(cameraSettings.position.x,cameraSettings.position.y,cameraSettings.position.z);
        this.camera.up.set(cameraSettings.up.x,cameraSettings.up.y,cameraSettings.up.z);
        this.camera.userData.target = new Vector3(cameraSettings.target.x,cameraSettings.target.y,cameraSettings.target.z);
        this.camera.fov = cameraSettings.fov;
        this.camera.lookAt(this.camera.userData.target);
        this.camera.updateProjectionMatrix();
        this.camera.updateMatrixWorld();
    } else {
        this.camera.position.set(this.width/2, this.height/2, 1000);
        this.camera.userData.target = new Vector3(this.width/2, this.height/2, 0);
        this.camera.lookAt(this.camera.userData.target);
        this.camera.updateProjectionMatrix();
        this.camera.updateMatrixWorld();
        await new findPlanePerspective(planeID, this.camera, photoID);
    }



    return this.camera;
}
